<udex-message-strip
  class="body--s udex-mb-16"
  design="Negative"
  status-type="Icon"
>
  {{'checkoutReview.error.orderHistoryProcessingNotFinished.message' | cxTranslate}}

  <udex-link class="udex-link--no-underline" href="" design="Default" (click)="openSupportForm()">
    {{'checkout.error.contactUs' | cxTranslate}}
  </udex-link>.
</udex-message-strip>
